import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./Login";
import AdminUpload from "./components/AdminUpload";
import UserGallery from "./components/UserGallery";
import ImageViewer from "./components/ImageViewer";
import PendingUsers from "./components/PendingUsers";
import ProtectedRoute from "./ProtectedRoute";
import LinkView from "./components/LinkView";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Default login */}
        <Route path="/" element={<Login />} />

        {/* Admin only: upload images */}
        <Route
          path="/admin/upload"
          element={
            <ProtectedRoute roleRequired="admin">
              <AdminUpload />
            </ProtectedRoute>
          }
        />

        {/* Admin only: pending users */}
        <Route
          path="/admin/pending-users"
          element={
            <ProtectedRoute roleRequired="admin">
              <PendingUsers />
            </ProtectedRoute>
          }
        />

        {/* User & Admin: gallery */}
        <Route
          path="/gallery"
          element={
            <ProtectedRoute>
              <UserGallery />
            </ProtectedRoute>
          }
        />

                {/* User & Admin: gallery */}
        <Route
          path="/link"
          element={
            <ProtectedRoute>
              <LinkView />
            </ProtectedRoute>
          }
        />

        {/* Image viewer */}
        <Route
          path="/view"
          element={
            <ProtectedRoute>
              <ImageViewer />
            </ProtectedRoute>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
